var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"block"},[_c('div',{staticClass:"w-full"},[_c('LeftCard')],1),_c('div',{staticClass:"w-full mt-8"},[_c('WireframeTab')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }